import { DivConst } from 'constants/divConst';
import DiagnosisStatusBadge from './DiagnosisStatusBadge';
import QuizStatusBadge from './QuizStatusBadge';
import FormStatusBadge from './FormStatusBadge';
import VoiceChatStatusBadge from './VoiceChatStatusBadge';

import type { JSX } from 'react';

/**
 * コンテンツステータス表示コンポーネント
 */
export default function ContentStatusBadge(props: {
  statusDiv: number | null;
  size?: 'normal' | 'large';
  contentsTypeDiv: number | null;
}): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      {props.contentsTypeDiv === DivConst.items.contentsType.quiz.value && (
        <QuizStatusBadge quizStatusDiv={props.statusDiv} size={props.size} />
      )}
      {props.contentsTypeDiv === DivConst.items.contentsType.diagnosis.value && (
        <DiagnosisStatusBadge diagnosisStatusDiv={props.statusDiv} size={props.size} />
      )}
      {props.contentsTypeDiv === DivConst.items.contentsType.form.value && (
        <FormStatusBadge formStatusDiv={props.statusDiv} size={props.size} />
      )}
      {props.contentsTypeDiv === DivConst.items.contentsType.voiceChat.value && (
        <VoiceChatStatusBadge voiceChatStatusDiv={props.statusDiv} size={props.size} />
      )}
    </>
  );
}
